// #3392 : UPS 레이블 + 홀박스 목록, 홀박스 레이블의 미리 렌더한 결과가 입력과 1:1 로 다 찍혔는지 판정한다.
// Stimulsoft 는 렌더 도중 예외를 삼키고 이미 만든 쪽만 남긴 채 콜백을 null 로 부른다. 그래서 콜백·쪽 수가 아니라
// 행·박스별 내용과 행 반복 뒤에만 찍히는 footer 를 본다. snapshot(stimulsoftRender.js 의 snapshotRenderedReport)만 받는 순수 함수다.

// #3392 : WholeBoxTicket.mrt Page3 > DataBand3 아래 leaf 15개. 템플릿에서 정적으로 정한 값이다(렌더 표본에서 배우지 않는다).
export const WHOLE_BOX_TICKET_REQUIRED_NAMES = ['Text95', 'Text85', 'Text90', 'Text91', 'Text96', 'Text97', 'Text98', 'Text99', 'Text100', 'Text93', 'Text92', 'BarCode1', 'Text1', 'Text2', 'TextWeight'];

const UPS_LABEL_PAGE_NAME = 'Page2';
const UPS_LABEL_IMAGE_NAME = 'Image2';
const WHOLE_BOX_TICKET_PAGE_NAME = 'Page3';
const LIST_ROW_NAMES = ['WbListClassCode', 'WbListClassName', 'WbListColorCode', 'WbListBoxQty'];
const PAGE_WIDTH = 400;
const PAGE_HEIGHT = 600;

// #3392 : Stimulsoft 는 JSON null 을 "" 로 바꿔 찍으므로 기대값도 같은 방식으로 만든다.
export function norm(v) {
	return v == null ? '' : String(v);
}

function pass() {
	return { ok: true, reason: '' };
}

function fail(reason) {
	return { ok: false, reason };
}

function isNumericText(text) {
	return typeof text === 'string' && text.trim() !== '' && Number.isFinite(Number(text));
}

function sameNumber(text, expected) {
	return isNumericText(text) && Number(text) === Number(expected);
}

// TextWeight 는 '{weight_per_box} lbs' 다. 무게가 없으면 Stimulsoft 가 ''(일부만 null) 또는 '0'(인보이스 전체가 null 이면 Decimal 0)으로 찍는다.
function sameWeightText(text, weight) {
	if (typeof text !== 'string' || !text.endsWith(' lbs')) return false;
	const value = text.slice(0, -4);
	if (weight === null || weight === undefined || weight === '') return value === '' || value === '0';
	return sameNumber(value, weight);
}

// 4x6(HundredthsOfInch 400x600) 원값으로 본다. width/height(여백 제외)나 page.unit 은 쓰지 않는다.
function checkGeometry(snapshot) {
	if (snapshot.report_unit_name !== 'HundredthsOfInch') return 'report unit is ' + snapshot.report_unit_name;
	for (let i = 0; i < snapshot.pages.length; i++) {
		const page = snapshot.pages[i];
		if (!(Math.abs(Number(page.page_width) - PAGE_WIDTH) <= 1) || !(Math.abs(Number(page.page_height) - PAGE_HEIGHT) <= 1)) return 'page ' + i + ' size is ' + page.page_width + 'x' + page.page_height;
		if (page.segment_per_width !== 1 || page.segment_per_height !== 1) return 'page ' + i + ' is segmented';
	}
	return null;
}

function checkSnapshotShape(snapshot) {
	if (!snapshot || !Array.isArray(snapshot.pages)) return 'no snapshot';
	for (let i = 0; i < snapshot.pages.length; i++) {
		if (!snapshot.pages[i] || !Array.isArray(snapshot.pages[i].components)) return 'page ' + i + ' has no component list';
	}
	if (snapshot.rendering_message_count !== 0) return 'rendering messages: ' + snapshot.rendering_message_count;
	return null;
}

function enabledByName(page, name) {
	return page.components.filter(c => c.name === name && c.enabled);
}

// UPS 레이블 쪽(Page2): 이미지 수만큼, 쪽마다 실제 이미지가 있는 Image2 1개. { indexes, error }
function checkUpsLabelPages(pages, image_count) {
	const indexes = [];
	pages.forEach((page, index) => {
		if (page.name === UPS_LABEL_PAGE_NAME) indexes.push(index);
	});
	if (indexes.length !== image_count) return { indexes, error: 'UPS label pages ' + indexes.length + ' != ' + image_count };
	for (const index of indexes) {
		const images = enabledByName(pages[index], UPS_LABEL_IMAGE_NAME);
		if (images.length !== 1 || images[0].has_image !== true) return { indexes, error: 'UPS label page ' + index + ' has no label image' };
	}
	return { indexes, error: null };
}

/**
 * #3392 : UPS 레이블 + 홀박스 목록 보고서(upsLabel.mrt)의 완결성.
 * expect = { image_count, rows: [{ class_code, class_name, color_code, box_qty }], list_page_name }
 */
export function verifyUpsListReport(snapshot, expect) {
	const shape_error = checkSnapshotShape(snapshot);
	if (shape_error) return fail(shape_error);
	const rows = expect && Array.isArray(expect.rows) ? expect.rows : null;
	if (!rows || rows.length === 0) return fail('no expected list rows');
	if (!Number.isInteger(expect.image_count) || expect.image_count < 1) return fail('no expected UPS label');
	const geometry_error = checkGeometry(snapshot);
	if (geometry_error) return fail(geometry_error);

	const pages = snapshot.pages;

	// UPS 레이블 쪽: 이미지 수만큼, 쪽마다 실제 이미지가 있는 Image2 1개
	const label_check = checkUpsLabelPages(pages, expect.image_count);
	if (label_check.error) return fail(label_check.error);
	const label_indexes = label_check.indexes;

	// 목록 쪽: 마지막 UPS 레이블 뒤에 연속으로, 보고서의 마지막 쪽들
	const list_indexes = [];
	pages.forEach((page, index) => {
		if (page.name === expect.list_page_name) list_indexes.push(index);
	});
	if (list_indexes.length < 1) return fail('no list page');
	const first_list = pages.length - list_indexes.length;
	if (!list_indexes.every((index, k) => index === first_list + k)) return fail('list pages are not the last pages');
	if (first_list <= label_indexes[label_indexes.length - 1]) return fail('list pages are not after UPS labels');

	// 목록 쪽의 text 는 평가 실패(null)나 미완성 자리표시자(#%#)가 없어야 한다.
	for (const index of list_indexes) {
		for (const c of pages[index].components) {
			if (c.type !== 'text') continue;
			if (c.text === null || c.text === undefined) return fail('list page ' + index + ' text ' + c.name + ' is null');
			if (String(c.text).startsWith('#%#')) return fail('list page ' + index + ' text ' + c.name + ' is a placeholder');
		}
	}

	// 행: 쪽 순서·컴포넌트 순서대로 모은 4열이 기대 행과 1:1
	const collected = {};
	LIST_ROW_NAMES.forEach(name => (collected[name] = []));
	let last_row_position = null;
	list_indexes.forEach(page_index => {
		pages[page_index].components.forEach((c, component_index) => {
			if (!c.enabled || !collected[c.name]) return;
			collected[c.name].push(c);
			last_row_position = [page_index, component_index];
		});
	});
	for (const name of LIST_ROW_NAMES) {
		if (collected[name].length !== rows.length) return fail(name + ' count ' + collected[name].length + ' != ' + rows.length);
	}
	for (let i = 0; i < rows.length; i++) {
		const row = rows[i];
		if (collected.WbListClassCode[i].text !== norm(row.class_code)) return fail('row ' + i + ' class code mismatch');
		if (collected.WbListClassName[i].text !== norm(row.class_name)) return fail('row ' + i + ' class name mismatch');
		if (collected.WbListColorCode[i].text !== norm(row.color_code)) return fail('row ' + i + ' color mismatch');
		if (!sameNumber(collected.WbListBoxQty[i].text, row.box_qty)) return fail('row ' + i + ' box qty mismatch');
	}

	// 완료 표식: 행 반복이 끝난 뒤에만 찍히는 footer 합계가 보고서 전체에 1번, 마지막 목록 쪽의 마지막 행 뒤에
	const last_page_index = pages.length - 1;
	const total_boxes = rows.reduce((sum, row) => sum + Number(row.box_qty), 0);
	const footer_checks = [
		['WbListTotalRows', rows.length],
		['WbListTotalBoxes', total_boxes],
	];
	for (const [name, expected] of footer_checks) {
		const found = [];
		pages.forEach((page, page_index) => {
			page.components.forEach((c, component_index) => {
				if (c.name === name) found.push({ c, page_index, component_index });
			});
		});
		if (found.length !== 1) return fail(name + ' count ' + found.length + ' != 1');
		const { c, page_index, component_index } = found[0];
		if (!c.enabled) return fail(name + ' is disabled');
		if (page_index !== last_page_index) return fail(name + ' is not on the last list page');
		if (last_row_position && (page_index < last_row_position[0] || (page_index === last_row_position[0] && component_index < last_row_position[1]))) return fail(name + ' is before the last row');
		if (!sameNumber(c.text, expected)) return fail(name + ' value mismatch');
	}

	return pass();
}

/**
 * #3392 : 목록 없이 미리 렌더한 UPS 레이블 보고서(upsLabel.mrt, wholeBoxList 없음)의 완결성. Whole Box Label 만 고른 출력에 쓴다.
 * expect = { image_count, list_page_name } : UPS 레이블 쪽 수·이미지, 목록 쪽 없음, 4x6, rendering message 0.
 */
export function verifyUpsReport(snapshot, expect) {
	const shape_error = checkSnapshotShape(snapshot);
	if (shape_error) return fail(shape_error);
	if (!expect || !Number.isInteger(expect.image_count) || expect.image_count < 1) return fail('no expected UPS label');
	const geometry_error = checkGeometry(snapshot);
	if (geometry_error) return fail(geometry_error);
	const label_check = checkUpsLabelPages(snapshot.pages, expect.image_count);
	if (label_check.error) return fail(label_check.error);
	if (snapshot.pages.some(page => page.name === expect.list_page_name)) return fail('unexpected list page');
	return pass();
}

/**
 * #3392 : 재배치한 보고서의 모든 쪽이 4x6(HundredthsOfInch 400x600, 분할 없음)인지만 본다. 내용은 재배치 전 검사로 끝났다.
 */
export function verifyPageGeometry(snapshot) {
	const shape_error = checkSnapshotShape(snapshot);
	if (shape_error) return fail(shape_error);
	if (snapshot.pages.length === 0) return fail('no pages');
	const geometry_error = checkGeometry(snapshot);
	if (geometry_error) return fail(geometry_error);
	return pass();
}

/**
 * #3392 : 인보이스 1건의 홀박스 레이블 보고서(WholeBoxTicket.mrt)의 완결성.
 * expect = { rows: wholeBoxPrintList, so_dn, required_names }
 */
export function verifyWholeBoxLabelReport(snapshot, expect) {
	const shape_error = checkSnapshotShape(snapshot);
	if (shape_error) return fail(shape_error);
	const rows = expect && Array.isArray(expect.rows) ? expect.rows : null;
	if (!rows || rows.length === 0) return fail('no expected whole box rows');
	const required_names = Array.isArray(expect.required_names) && expect.required_names.length > 0 ? expect.required_names : WHOLE_BOX_TICKET_REQUIRED_NAMES;
	// 실패한 행 자리에 빈 쪽이 남을 수 있으므로 쪽 수는 필요조건일 뿐이다.
	if (snapshot.pages.length !== rows.length) return fail('label pages ' + snapshot.pages.length + ' != ' + rows.length);
	const geometry_error = checkGeometry(snapshot);
	if (geometry_error) return fail(geometry_error);

	for (let i = 0; i < rows.length; i++) {
		const page = snapshot.pages[i];
		const row = rows[i];
		if (page.name !== WHOLE_BOX_TICKET_PAGE_NAME) return fail('label page ' + i + ' is ' + page.name);
		const by_name = {};
		for (const name of required_names) {
			const found = enabledByName(page, name);
			if (found.length !== 1) return fail('label page ' + i + ' has ' + found.length + ' ' + name);
			const c = found[0];
			if (name === 'BarCode1') {
				if (c.type !== 'barcode' || c.code_value === null || c.code_value === undefined) return fail('label page ' + i + ' barcode is null');
			} else if (c.type !== 'text' || c.text === null || c.text === undefined) {
				return fail('label page ' + i + ' text ' + name + ' is null');
			}
			by_name[name] = c;
		}
		const value_checks = [
			['Text97', norm(expect.so_dn)],
			['Text98', norm(row.class_code)],
			['Text99', norm(row.class_name)],
			['Text100', '#' + norm(row.color_code)],
		];
		for (const [name, expected] of value_checks) {
			if (!by_name[name] || by_name[name].text !== expected) return fail('label page ' + i + ' ' + name + ' mismatch');
		}
		if (!by_name.TextWeight || !sameWeightText(by_name.TextWeight.text, row.weight_per_box)) return fail('label page ' + i + ' TextWeight mismatch');
		if (!by_name.BarCode1 || by_name.BarCode1.code_value !== norm(row.barcode)) return fail('label page ' + i + ' barcode mismatch');
	}

	return pass();
}
